import HttpClient from '../utils/http-client';
import { firstValueFrom } from 'rxjs';

const getClient = (companyId?: string | number) => {
    const uid = localStorage.getItem('user_uid') || '';
    const cid = companyId ? String(companyId) : (localStorage.getItem('cid') || null);
    return new HttpClient(uid, cid);
};

export const pipelineService = {
    uploadDocuments: async (files: File[], companyId?: string | number, passwords?: Record<string, string>, uaId?: number, statementBalance?: number) => {
        const client = getClient(companyId);
        const formData = new FormData();
        files.forEach((file) => {
            formData.append('files', file);
        });
        if (passwords) {
            formData.append('passwords', JSON.stringify(passwords));
        }
        if (uaId !== undefined) {
            formData.append('ua_id', String(uaId));
        }
        if (statementBalance !== undefined) {
            formData.append('statement_balance', String(statementBalance));
        }
        
        const obs = client.post<any>('/pipeline/upload', formData);
        return firstValueFrom(obs);
    },

    getDrafts: async (page = 1, limit = 10, status = 'pending', companyId?: string | number) => {
        const client = getClient(companyId);
        const obs = client.get<any>(`/pipeline/drafts?page=${page}&limit=${limit}&status=${status}`);
        return firstValueFrom(obs);
    },

    getDraftDetail: async (id: number, companyId?: string | number) => {
        const client = getClient(companyId);
        const obs = client.get<any>(`/pipeline/drafts/${id}`);
        return firstValueFrom(obs);
    },

    deleteDraft: async (id: number, companyId?: string | number) => {
        const client = getClient(companyId);
        const obs = client.delete<any>(`/pipeline/drafts/${id}`);
        return firstValueFrom(obs);
    },

    approveDraft: async (id: number, data: any, companyId?: string | number) => {
        const client = getClient(companyId);
        const obs = client.post<any>(`/pipeline/drafts/${id}/approve`, data);
        return firstValueFrom(obs);
    },

    updateDraft: async (id: number, data: any, companyId?: string | number) => {
        const client = getClient(companyId);
        const obs = client.put<any>(`/pipeline/drafts/${id}`, data);
        return firstValueFrom(obs);
    },

    getDocumentTypes: async (companyId?: string | number) => {
        const client = getClient(companyId);
        const obs = client.get<any>('/pipeline/document-types');
        return firstValueFrom(obs);
    },

    reprocessDraft: async (id: number, docType: string, companyId?: string | number) => {
        const client = getClient(companyId);
        const obs = client.post<any>(`/pipeline/drafts/${id}/reprocess`, { doc_type: docType });
        return firstValueFrom(obs);
    }
};
